import { render } from "./CompanySettingsModal.vue?vue&type=template&id=22f48794"
import script from "./CompanySettingsModal.vue?vue&type=script&lang=js"
export * from "./CompanySettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__